import { render, staticRenderFns } from "./BackLogo.vue?vue&type=template&id=28b4611e&"
import script from "./BackLogo.vue?vue&type=script&lang=js&"
export * from "./BackLogo.vue?vue&type=script&lang=js&"
import style0 from "./BackLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports